const home = {
  slides: [
    { tag: "Недвижимость в Дубае",  title0: "Исключительная",   title1: "недвижимость в Дубае", sub: "Отборные премиум-резиденции и инвестиционные возможности по всем Эмиратам." },
    { tag: "Виллы на выбор",         title0: "Роскошные виллы",  title1: "Пальма Джумейра",      sub: "Частные пляжные резиденции с панорамным видом на море и первоклассными удобствами." },
    { tag: "Премиум апартаменты",    title0: "Современная жизнь",title1: "Даунтаун Дубай",       sub: "Изысканные апартаменты с потрясающим видом на Бурдж-Халифа в самом сердце города." },
  ],
  scroll: "Листать",
  search: {
    type:       "Тип",
    typeAll:    "Все типы",
    location:   "Локация",
    locAll:     "Все Эмираты",
    beds:       "Спальни",
    status:     "Статус",
    statusAll:  "Купить или снять",
    statusSale: "Продажа",
    statusRent: "Аренда",
    btn:        "Найти",
  },
  stats: {
    availability: "Доступность",
    support:      "Полная поддержка",
    satisfaction: "Довольных клиентов",
    emirates:     "Эмирата",
  },
  featured: {
    eyebrow:  "Избранная недвижимость",
    title:    "Премиум",
    titleEm:  "объявления",
    viewAll:  "Смотреть все",
  },
  bigFeature: {
    eyebrow:  "Избранный объект · Испания",
    desc:     "Просторная вилла с панорамным видом на море. Бассейн-инфинити, спа, тренажёрный зал, полная меблировка — на первой линии гольф-поля в Бенахавис.",
    viewProp: "Смотреть объект",
  },
  services: {
    eyebrow:  "Что мы предлагаем",
    title:    "Наши",
    titleEm:  "услуги",
    items: [
      { title: "Покупка и продажа",    desc: "Полное сопровождение от первого просмотра до передачи ключей. Каждый шаг — чётко и прозрачно." },
      { title: "Аренда",               desc: "Рыночная цена, проверка арендаторов, договоры — в соответствии с законодательством ОАЭ." },
      { title: "Ипотека",              desc: "Экспертная помощь в выборе финансирования и оптимального плана оплаты." },
      { title: "Оформление сделки",    desc: "Полный пакет документов и координация с застройщиками, банками и госорганами." },
    ],
  },
  partners: {
    label: "В партнёрстве с ведущими застройщиками ОАЭ",
  },
  cta: {
    title0:   "Готовы найти вашу",
    title1:   "недвижимость мечты?",
    sub:      "Наши агенты работают 7 дней в неделю по всем Эмиратам.",
    whatsapp: "Написать в WhatsApp",
    send:     "Отправить сообщение",
  },
};

export default home;
